import React, { useState } from "react";
import { Row, Col, Input, Upload, Button, Form, message } from "antd";
import { UploadOutlined, AudioOutlined, CloudUploadOutlined } from "@ant-design/icons";
import ModelWrapper from "../../../modal/ModelWrapper";
import { CustomButton, CustomSecondaryButton } from "../styled";
import recordingService from "../../../../services/recording";
import { FileUploadContainer } from "../../myprofile/MyProfilePage";

const { TextArea } = Input;

const UploadRecordingModal = ({
  isOpen,
  setIsOpen,
  onUpload,
  isLoading = false,
  recordingId,
  fetchAudioFiles
}) => {
  const [form] = Form.useForm();
  const [fileList, setFileList] = useState([]);
  const [file, setFile] = useState(null);

  const handleSubmit = async (values) => {
  //  console.log("values", values);
  //  console.log("file", file);
  //  console.log("recordingId", recordingId);
    try {
      const formData = new FormData();
      formData.append("recordingId", recordingId);
      formData.append("name", values.name);
      formData.append("comment", values.comment || "");
      formData.append("file", file);
      
      // Log FormData contents properly
      // console.log("FormData contents:", formData);
     

      const res = await recordingService.uploadClonnedVoice(formData);


      form.resetFields();
      setFileList([]);
      setIsOpen(false);
      fetchAudioFiles();
    } catch (error) {
      console.error("Upload failed:", error);
    }
  };

  const handleCancel = () => {
    form.resetFields();
    setFileList([]);
    setIsOpen(false);
  };

  return (
    <ModelWrapper
      title={
        <div className="row-flex flex-column">
          <h3 className="font-18 font-semibold text-primary mb-5">
            Upload Recording
          </h3>
          <p className="font-14 text-secondry mb-0">
            Upload a new voice recording file
          </p>
        </div>
      }
      footer={null}
      show={isOpen}
      setShow={setIsOpen}
      width={600}
      keyClose={false}
      className="custom-detail-modal"
      bodyStyle={{
        maxHeight: "80vh",
        overflow: "auto",
        padding: "20px",
      }}
    >
      <Form
        form={form}
        layout="vertical"
        onFinish={handleSubmit}
        requiredMark="optional"
      >
        <Row gutter={[24]}>
          <Col span={24}>
            <Form.Item
              name="name"
              label="Recording Name"
              rules={[
                { required: true, message: "Please enter the recording name!" },
                { max: 100, message: "Name must be less than 100 characters!" },
              ]}
            >
              <Input
                placeholder="Enter recording name"
                size="large"
                // prefix={<AudioOutlined style={{ color: "#8A3EF4" }} />}
              />
            </Form.Item>
          </Col>

          <Col span={24}>
            <Form.Item
              name="comment"
              label="Comment (Optional)"
              rules={[
                {
                  max: 500,
                  message: "Comment must be less than 500 characters!",
                },
              ]}
            >
              <TextArea
                placeholder="Add any additional comments about this recording..."
                rows={4}
                maxLength={500}
                showCount
              />
            </Form.Item>
          </Col>

          <Col span={24}>
            <Form.Item
              label="Upload File"
              required
            >
              <FileUploadContainer>
              <Upload.Dragger
                name="file"
                multiple={false}
                accept=".mp3, .wav, .m4a, .ogg, .aac, .mp4"
                beforeUpload={() => false}
                disabled={isLoading}
                onChange={(info) => {
                  setFile(info.file);
                }}
                maxCount={1}
              >
                <p className="ant-upload-drag-icon" style={{ color: "var(--primary-text-color)" }}>
                  <CloudUploadOutlined style={{ color: "#" }} />
                </p>
                <p className="ant-upload-text" style={{ color: "var(--primary-text-color)" }}>
                  Click or drag audio file to this area to upload
                </p>
                <p className="upload-hint">
                  Supports: MP4, MP3, WAV, M4A, OGG, AAC formats
                </p>
              </Upload.Dragger>
              </FileUploadContainer>
            </Form.Item>
          </Col>

          <Col span={24} className="d-flex justify-end gap-12">
            <CustomSecondaryButton
              onClick={handleCancel}
              disabled={isLoading}
              size="large"
            >
              Cancel
            </CustomSecondaryButton>
            <CustomButton
              htmlType="submit"
              loading={isLoading}
              size="large"
            >
              {isLoading ? "Uploading..." : "Upload Recording"}
            </CustomButton>
          </Col>
        </Row>
      </Form>
    </ModelWrapper>
  );
};

export default UploadRecordingModal;
